// import store from '../store/index'
//------------------
// set rune values
//------------------
export default function setRuneValues() {
  console.log('----------------------------')
  console.log('IN setRuneValues')
  // -----------------
  // define structure
  // -----------------
  let rune = {
    //
    name: '',
    notes: '',
    //
    id: 0,
    strength: 0,
    pwr_storage: 0,
    //
    starter: false,
    integrated: false,
    //
    character_item: null,
  }
  return rune
}
